import React, { useEffect, useCallback } from "react";
import { css } from "emotion";
import { NavLink } from "react-router-dom";

import { boxFinishedOffer, boxUnsucccess } from "./style";

import CreateOfferRegistered from "./CreateOfferRegistered";
import CreateInfoRegistered from "./CreateInfoRegistered";
import CreateInfoFinishedOffer from "./CreateInfoFinishedOffer";

import { useNewOffer } from "../../../../../../js/context/new-offer";
import { FAMILY_ACCOUNT_BANNER_REGISTERED_OFFER, ROUTE_HOME } from "../../../../../shared/constants";

import { publish } from "pubsub-js";
import eventType from "../../../../../events/eventType";
import { FamilyAccountBanner } from "../../../../../../shared/FamilyAccountBanner/FamilyAccountBanner";

const CreateOfferResult = props => {
	const { offerSentStatus, currentProgram, offerData, editOffer, loyaltyData } = useNewOffer();

	useEffect(() => {
		if (offerSentStatus.success) {
			registerEvent();
		}
	}, [registerEvent, offerSentStatus]);

	const registerEvent = useCallback(() => {
		const { fidelityName, international } = currentProgram;
		const { quant: quantityMiles, price: priceMiles, averageMiles } = offerData?.data;
		const step = "conclusao-oferta";
		const { paymentDeadline } = editOffer;
		const { twoFactorAuthenticationStrategy } = loyaltyData?.data;

		publish(eventType.OFFER_CONTENT_MOBILE, {
			fidelityName,
			international,
			quantityMiles,
			priceMiles,
			step,
			averageMiles,
			paymentDeadline,
			twoFactorAuthenticationStrategy
		});
	}, [currentProgram, offerData, editOffer, loyaltyData]);

	return offerSentStatus.success ? (
		<div
			className={css`
				${boxFinishedOffer}
			`}
		>
			<FamilyAccountBanner contentType={FAMILY_ACCOUNT_BANNER_REGISTERED_OFFER} />
			<div className="layout--box-offer-registered">
				<CreateOfferRegistered typePhoneLatam={props.typePhoneLatam} />
			</div>
			<div className="layout--box-info-registered">
				<CreateInfoRegistered typePhoneLatam={props.typePhoneLatam} />
			</div>
			<div className="layout--box-info-finished-offer">
				<CreateInfoFinishedOffer typePhoneLatam={props.typePhoneLatam} />
			</div>
		</div>
	) : (
		<div
			className={css`
				${boxUnsucccess}
			`}
		>
			<strong>Não conseguimos concluir sua oferta</strong>
			<span>
				Algo deu errado na hora de cadastrar esta oferta. Tente novamente ou entre em contato com a
				gente.
			</span>
			<NavLink className="btn-primary-md" to={`${ROUTE_HOME}`} onClick={() => clearContext()}>
				Tentar novamente
			</NavLink>
			<div className="box-companies--none--unsuccess" />
		</div>
	);
};

export default CreateOfferResult;
